import Banner from '../Home/Banner';

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      {/* Left: Banner (desktop half, mobile full) */}
      <div className="md:w-1/2 h-80 md:h-screen">
        <Banner />
      </div>

      {/* Right: Auth panel area */}
      <div className="md:w-1/2 p-6 bg-white md:h-screen" style={{overflow:'auto',alignContent:'center'}}>
        <div className="w-full max-w-md mx-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PublicLayout;
